import { Layout } from '@/components/Layout/Layout';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { SlugPageController } from 'server/controller/page/index/slugPageController';
import type { ISlugPageResource } from 'server/resource/page/slugPageResource';
import type { IGlobalMetaData } from 'types/IGlobalMetaData';
import ClientSlugPage from '../components/PageLevelComponents/ClientSlugPage';

const RootPage = (props: ISlugPageResource) => {
  const {
    metaData,
    data,
    breadcrumbsCMSData,
    difficultyCopy,
    searchOverlayData,
    searchItemLabels,
    recipeCopy,
    footerNavData,
    footerImage,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    locale,
    pathTranslations,
    userToken,
    globalDictionary,
    isPromotionPage,
  } = props;

  return (
    <Layout
      themeName={data?.genericPages.at(0)?.theme || ''}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
      isPromotionPage={isPromotionPage}
    >
      <ClientSlugPage
        globalMetadata={metaData as IGlobalMetaData}
        data={data}
        breadcrumbsCMSData={breadcrumbsCMSData}
        recipeCopy={recipeCopy}
        difficultyCopy={difficultyCopy as Record<string, string>}
        searchItemLabels={searchItemLabels as Record<string, string>}
        searchOverlayData={searchOverlayData}
        themeName={data?.genericPages.at(0)?.theme || ''}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return SlugPageController.getCachedSlugPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params?.slug.join('/') : (params?.slug ?? ''),
    userToken: anonymousToken ?? '',
  });
};

export default RootPage;
